module.exports = __webpack_public_path__ + "901daeaa8c640f4cc2dbadec0c2362a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TextAppLink/apps@2x.png
// module id = 2040
// module chunks = 0 1